<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <md-card class="p-25">
            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="employees"
                    v-model="EmployeeId"
                    option-value="key"
                    option-text="value"
                    placeholder="الموظف"
                  >
                  </model-list-select>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <md-field>
                    <label>الوحدة التنظيمية</label>
                    <md-select v-model="DepartmentId">
                      <md-option
                        v-for="department in departments"
                        v-bind:key="department.id"
                        :value="department.id"
                        >{{ department.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <md-field>
                    <label>نوع العذر</label>

                    <md-select v-model="ExcuseType">
                      ] <md-option value="1">حضور متأخر</md-option>
                      <md-option value="2">خروج مبكر / اذن خروج </md-option>
                      <md-option value="3">غياب</md-option>
                      <md-option value="4">خروج بدون بصمة</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="date">
                    <label class="mr-28">التاريخ</label>
                  </md-datepicker>
                </div>

                <div
                  class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                >
                  <md-button @click="Search" class="md-success btn_nanosoft"
                    >بحث</md-button
                  >
                  <md-button @click="New" class="md-info btn_nanosoft"
                    >جديد</md-button
                  >

                  <md-button class="md-info btn_nanosoft">طباعة</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <md-table
            :value="tableData"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="المستهدف">{{ item.for }}</md-table-cell>

              <md-table-cell md-label="التاريخ">{{
                convert(item.date)
              }}</md-table-cell>

              <md-table-cell v-if="item.type == '1'" md-label="نوع العذر">
                حضور متأخر
              </md-table-cell>

              <md-table-cell v-else-if="item.type == '2'" md-label="نوع العذر">
                خروج مبكر / اذن خروج
              </md-table-cell>

              <md-table-cell v-else-if="item.type == '3'" md-label="نوع العذر">
                غياب
              </md-table-cell>

              <md-table-cell v-else-if="item.type == '4'" md-label="نوع العذر">
                خروج بدون بصمة
              </md-table-cell>

              <md-table-cell v-else md-label="نوع العذر"> </md-table-cell>

              <md-table-cell md-label="ملاحظة">{{ item.note }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
  },
  components: {
    Pagination,
    ModelListSelect,
  },
  watch: {
    pagination: {
      deep: true,
      handler(newValue, oldValue) {
        this.Search();
      },
    },
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  data() {
    return {
      errorMessage: "",
      EmployeeId: "",
      DepartmentId: "",
      ExcuseType: "",
      date: null,
      departments: [],

      tableData: [],
      btn: "new",
      idTable: "",
      employees: [],
      updateStatus: "",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (this.date == null) {
          this.date = null;
        } else {
          this.date = this.convert(this.date);
        }

        const params = {
          EmployeeId: this.EmployeeId,
          DepartmentId: this.DepartmentId,
          ExcuseType: this.ExcuseType,
          Date: this.date,
          currentPage: this.pagination.currentPage,
        };

        let result = await axios.get(`${env.HR()}/api/Excuses/filter`, {
          params,
          headers: { Authorization: "Bearer " + token },
        });
        this.tableData = result.data.data.results;
        this.pagination.total = result.data.data.total;
      } catch (error) {
        this.message(error);
      }
    },
    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/Excuses`, {
          headers: { Authorization: "Bearer " + token },
        });

        this.employees = result.data.data.employees;
        this.departments = result.data.data.departments;
        this.tableData = result.data.data.excuse;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    New() {
      localStorage.setItem("idTable", "");
      this.$router.push("Excuses/new");
    },

    handleEdit(item) {
      this.$router.push(`Excuses/${item.id}`);
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/Excuses/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
};
</script>
